import { Box } from '@chakra-ui/react';

import { TextRegular } from 'UiKit/typography';
import { Condition } from 'Component/others';

import styles from './styles.module.css';

const ColumnTargetEcommerce = ({ values, ecommerce }) => {
  const isTiktok = ecommerce === 'Tiktok';

  return (
    <Box className={styles['column__container']}>
      {/* Left side */}
      <Box className={styles['column__side']}>
        <Box className={styles['column__row']}>
          <TextRegular className={styles['column__label']}>AOV</TextRegular>
          <TextRegular className={styles['column__value']}>: {values?.aov}</TextRegular>
        </Box>
        <Box className={styles['column__row']}>
          <TextRegular className={styles['column__label']}>Views</TextRegular>
          <TextRegular className={styles['column__value']}>: {values?.views}</TextRegular>
        </Box>
      </Box>

      {/* Right side */}
      <Box className={styles['column__side']}>
        <Box className={styles['column__row']}>
          <TextRegular className={styles['column__label']}>CTR</TextRegular>
          <TextRegular className={styles['column__value']}>: {values?.ctr}</TextRegular>
        </Box>
        <Box className={styles['column__row']}>
          <TextRegular className={styles['column__label']}>CTOR</TextRegular>
          <TextRegular className={styles['column__value']}>: {values?.ctor}</TextRegular>
        </Box>
        <Condition
          statement={isTiktok}
          children={
            <Box className={styles['column__row']}>
              <TextRegular className={styles['column__label']}>ERR</TextRegular>
              <TextRegular className={styles['column__value']}>: {values?.err}</TextRegular>
            </Box>
          }
        />
      </Box>
    </Box>
  );
};

export default ColumnTargetEcommerce;
